import * as React from "react";
import {Badge} from "react-bootstrap";
import StoragePlaceInventory from "./StoragePlaceInventory";
import {useTranslation} from 'react-i18next';

const prepareStorageInventory = (storageInventory) => {
    storageInventory.storageInventoryDetails.forEach(details => {
        storageInventory[details.code] = details.result
    })

    return storageInventory;
}

const useTableColumns = () => {
    const {t} = useTranslation();

    return [
        {
            label: t("forms.last_review"),
            field: "lastInventoryDate",
            sort: "desc",
            width: 150,
        },
        {
            label: t("forms.next_review_date"),
            field: "nextInventoryDate",
            sort: "desc",
            width: 150,
        }
    ];
};

const columns = (t) => [
    {
        label: t ? t("common.name") : "Nazwa",
        field: "name",
        sort: "desc",
        width: 53,
    },
    {
        label: t ? t("common.comment") : "Komentarz",
        field: "comment",
        sort: "desc",
        type: "textarea",
        width: 53,
    },
    {
        label: t ? t("common.last_review") : "Ostatni przegląd",
        field: "storageInventory",
        sort: "desc",
        width: 53,
        type: "custom",
        custom: function (column, row, history) {
            return <>

                {
                    row.storageInventory &&
                    <StoragePlaceInventory storagePlaceInventory={prepareStorageInventory(row.storageInventory)}/>

                }
                {
                    !row.storageInventory &&
                    <Badge variant={"dark"} className={"font-max"}>{t ? t("common.none") : "Brak"}</Badge>
                }
            </>
        }

    },
    {
        label: t ? t("forms.next_review_date") : "Data następnego przeglądu",
        field: "nextInventoryDate",
        type: "custom",
        sort: "desc",
        width: 53,
        custom: function (column, row, history) {
            const today = new Date();
            const nextInventoryDate = new Date(row.nextInventoryDate);

            return (
                <>
                    {row.nextInventoryDate && (
                        <Badge className="mr-1 font-max"
                               variant={today > nextInventoryDate ? "danger" : "primary"}>
                            {row.nextInventoryDate}
                        </Badge>
                    )}
                </>
            );
        }

    },

];

export default columns;